module.exports = __webpack_public_path__ + "img/work.6c8d5ee.svg";